import { useEffect } from 'react';

const siteUrl = import.meta.env.VITE_SITE_URL || 'https://tribuvoyage.com';

const eventSchema = {
  '@context': 'https://schema.org',
  '@type': 'Event',
  name: 'Renaissance au Soleil – Séjour Déconnexion Maroc',
  description:
    '7 jours de déconnexion au Maroc entre Marrakech, Essaouira et le désert d\'Agafay. Yoga, hammam, cercle de femmes, balade à dos de dromadaire, cuisine marocaine. Petit groupe intimiste de 8 à 10 personnes.',
  startDate: '2026-05-11',
  endDate: '2026-05-17',
  eventStatus: 'https://schema.org/EventScheduled',
  eventAttendanceMode: 'https://schema.org/OfflineEventAttendanceMode',
  location: {
    '@type': 'Place',
    name: 'Marrakech, Maroc',
    address: {
      '@type': 'PostalAddress',
      addressCountry: 'MA',
      addressLocality: 'Marrakech',
    },
  },
  organizer: {
    '@type': 'Organization',
    name: 'TribuVoyage',
    email: 'tribuvoyage10@gmail.com',
    url: siteUrl,
  },
  offers: {
    '@type': 'Offer',
    price: '1899',
    priceCurrency: 'EUR',
    availability: 'https://schema.org/LimitedAvailability',
    validThrough: '2026-04-27',
    url: `${siteUrl}/#reservation`,
  },
  url: `${siteUrl}/`,
  image: `${siteUrl}/og-image.jpg`,
  inLanguage: 'fr',
};

const organizationSchema = {
  '@context': 'https://schema.org',
  '@type': 'Organization',
  name: 'TribuVoyage',
  url: `${siteUrl}/`,
  email: 'tribuvoyage10@gmail.com',
  description:
    'TribuVoyage organise des séjours de déconnexion authentiques en petit groupe intimiste au Maroc. Yoga, bien-être, nature et partage.',
  address: {
    '@type': 'PostalAddress',
    addressCountry: 'MA',
    addressLocality: 'Marrakech',
  },
};

const faqSchema = {
  '@context': 'https://schema.org',
  '@type': 'FAQPage',
  mainEntity: [
    {
      '@type': 'Question',
      name: 'À qui s\'adresse ce séjour ?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'Ce voyage est conçu pour toute personne souhaitant se déconnecter à la fois des écrans et du rythme intense du quotidien, profiter de la nature, du calme et se recentrer sur soi, tout en partageant des moments privilégiés dans un petit groupe de 8 à 10 personnes.',
      },
    },
    {
      '@type': 'Question',
      name: 'Faut-il être sportif(ve) ?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'Non, toutes les activités sont accessibles à tous les niveaux : marches douces dans l\'Atlas, yoga sur la plage ou face aux montagnes, balades contemplatives et relaxation guidée.',
      },
    },
    {
      '@type': 'Question',
      name: 'Que comprend le prix de 1 899 € ?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'Le prix comprend : hébergement partagé et confort, pension complète (cuisine marocaine raffinée), toutes les activités mentionnées dans le programme (yoga, hammam, balades, cercle de femmes, massages…), transferts locaux et accueil à l\'aéroport, assistance sur place 24h/24. Le billet d\'avion n\'est pas inclus.',
      },
    },
    {
      '@type': 'Question',
      name: 'Combien de personnes par groupe ?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'Minimum 8 et maximum 10 participants pour garantir une expérience intimiste et de qualité. Les inscriptions ferment une fois le groupe complet.',
      },
    },
    {
      '@type': 'Question',
      name: 'Peut-on payer en plusieurs fois ?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'Oui, un acompte permet de réserver votre place, et le solde peut être échelonné selon vos besoins.',
      },
    },
    {
      '@type': 'Question',
      name: 'Quel temps fait-il au Maroc en mai ?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: '22 à 28°C en journée, doux le soir. Soleil, peu de pluie. C\'est la saison idéale pour ce voyage.',
      },
    },
    {
      '@type': 'Question',
      name: 'Y aura-t-il du wifi ou du réseau ?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'Certains hébergements peuvent proposer du wifi, mais le séjour encourage une vraie déconnexion pour profiter pleinement de l\'expérience.',
      },
    },
    {
      '@type': 'Question',
      name: 'Que se passe-t-il si le séjour est complet ?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'Une fois le nombre maximum de participants atteint, les inscriptions sont closes afin de préserver l\'expérience intimiste et la qualité du séjour.',
      },
    },
  ],
};

const tourPackageSchema = {
  '@context': 'https://schema.org',
  '@type': 'TouristTrip',
  name: 'Renaissance au Soleil – 7 jours au Maroc',
  description:
    'Séjour de déconnexion de 7 jours au Maroc : Marrakech, vallée d\'Ouirgane, Essaouira, désert d\'Agafay. Yoga, hammam traditionnel, cuisine marocaine, cercle de femmes.',
  touristType: 'Wellness Tourism',
  itinerary: {
    '@type': 'ItemList',
    itemListElement: [
      { '@type': 'ListItem', position: 1, name: 'Jour 1 – Marrakech : Accueil & Lâcher-prise' },
      { '@type': 'ListItem', position: 2, name: 'Jour 2 – Vallée d\'Ouirgane : Nature & Douceur' },
      { '@type': 'ListItem', position: 3, name: 'Jour 3 – Essaouira : Océan & Sérénité' },
      { '@type': 'ListItem', position: 4, name: 'Jour 4 – Essaouira : Bien-être & Temps pour soi' },
      { '@type': 'ListItem', position: 5, name: 'Jour 5 – Désert d\'Agafay : Silence & Sororité' },
      { '@type': 'ListItem', position: 6, name: 'Jour 6 – Marrakech : Spa & Relaxation' },
      { '@type': 'ListItem', position: 7, name: 'Jour 7 – Départ' },
    ],
  },
  offers: {
    '@type': 'Offer',
    price: '1899',
    priceCurrency: 'EUR',
    availability: 'https://schema.org/LimitedAvailability',
    url: `${siteUrl}/#reservation`,
  },
};

function injectSchema(id: string, data: object) {
  const existing = document.getElementById(id);
  if (existing) existing.remove();
  const script = document.createElement('script');
  script.type = 'application/ld+json';
  script.id = id;
  script.textContent = JSON.stringify(data, null, 2);
  document.head.appendChild(script);
}

export default function SEOSchemas() {
  useEffect(() => {
    injectSchema('schema-event', eventSchema);
    injectSchema('schema-organization', organizationSchema);
    injectSchema('schema-faq', faqSchema);
    injectSchema('schema-tour', tourPackageSchema);

    return () => {
      ['schema-event', 'schema-organization', 'schema-faq', 'schema-tour'].forEach((id) => {
        document.getElementById(id)?.remove();
      });
    };
  }, []);

  return null;
}
